//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/date_box'

//#endregion

import { USER_SESSION_SERVICE_NAME } from '../../../../../services/user-session'
import { IMRBaseComponent } from '../../../base'
import { ImmediatelyArchDateActionController } from './action-run.dedicated.immediately-get-archive.controller'

export const COMPONENT_NAME: string = 'immediatelyGetArchiveAction'

//#region Asset Imports

import './action-run.dedicated.immediately-get-archive.scss'
import * as TEMPLATE from './action-run.dedicated.immediately-get-archive.tpl.html'

//#endregion

export class ImmediatelyArchDateActionComponent extends IMRBaseComponent {
    constructor() {
        super({
            controller: ImmediatelyArchDateActionController,
            template: TEMPLATE,
            services: [USER_SESSION_SERVICE_NAME],
        })
    }
}
